import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import * as moment from 'moment';

@Component({
  selector: 'app-consignment-form',
  templateUrl: './consignment-form.component.html',
  styleUrls: ['./consignment-form.component.scss']
})
export class ConsignmentFormComponent implements OnInit {

  public form: FormGroup;
  public buttonLabel = 'Ajouter';
  constructor(private fb: FormBuilder,
    public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.form = fb.group({
      amount: [null, [Validators.required]],
      date_consignment: [moment().format('YYYY-MM-DD'), [Validators.required]],
      comment: [null, []],
    })
  }

  ngOnInit() {
    if (this.config.data) {
      this.form.patchValue(this.config.data);
      this.buttonLabel = 'Modifier';
    }
  }
  save() {
    if (this.form.valid) {
      this.ref.close(this.form.value);
    }

  }
}
